/**
 * Tariflar — AdminTariffPage va boshqa joylar uchun tiplar va foyda kalitlari.
 * Tariflar ro'yxati backenddan keladi.
 */

export interface TariffPlan {
  id: string;
  typeKey: string | null;
  customName: string | null;
  monthlyPrice: number;
  benefits: string[];
  recommended: boolean;
}

/** Seeder bilan mos standart tarif turlari (yangi tarifda shablon sifatida) */
export const STANDARD_TARIFF_TYPE_KEYS = ['start', 'businessSmall', 'businessMedium', 'businessEnterprise'] as const;

export const NEW_TARIFF_DRAFT_ID = '__new__';

export const ALL_BENEFIT_KEYS: string[] = [
  'benefitUpTo10Users',
  'benefitUpTo50Users',
  'benefitUnlimitedUsers',
  'benefitBasicCRM',
  'benefitFullCRM',
  'benefitEssentialReports',
  'benefitAdvancedAnalytics',
  'benefitEmailSupport',
  'benefitPrioritySupport',
  'benefitAILocation',
  'benefitOnlineSalesExtra',
  'benefitOnlineSalesFree',
  'benefitCustomIntegrations',
  'benefitAISuite',
  'benefitDedicatedManager',
  'benefit24x7Support',
  'benefitMonthlyDiscount',
  'benefitOneBranch',
  'benefitOneCashier',
  'benefitProducts1000',
  'benefitRetailClients1000',
  'benefitBranches3',
  'benefitCashiers10',
  'benefitUnlimitedProducts',
  'benefitRetailClients5000',
  'benefitAIAdvisor',
  'benefitMarketingOnlinePaidAddon',
  'benefitBranches5',
  'benefitCashiers20',
  'benefitRetailClients20000',
  'benefitMarketingTools',
  'benefitOnlineOrdersFree',
  'benefitUnlimitedBranches',
  'benefitUnlimitedCashiers',
  'benefitUnlimitedRetailClients',
];
